export default __webpack_public_path__ + "static/media/close-white-icon.7e962257.svg";